<template>
    <el-container class="layout_container">
        <el-aside :width="nav_width" class="aside">
            <index-meu-component class="menu"></index-meu-component>
        </el-aside>
        <el-container>
            <el-header>
                <index-header-component></index-header-component>
            </el-header>
            <el-main class="main" id="el_main">
                <!-- 子路由出口 -->
                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import '@/assets/style/index/index_view.css'

import { AuthList } from '@/network/user.js'
import IndexMeuComponent from '@/components/index/IndexMeuComponent'
import IndexHeaderComponent from '@/components/index/IndexHeaderComponent'

export default {
    name: 'IndexView',
    data() {
        return {}
    },
    computed: {
        nav_width() {
            return this.$store.state.isCollapse ? 'auto' : '220px'
        }
    },
    methods: {
        get_auth_list() {
            AuthList()
                .then((s) => {
                    if (s.status === 0) {
                        this.$store.commit('edit_auth_list', s.result)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.$message.error(err)
                })
        },
    },
    filters: {},
    props: {},
    created() {
        this.get_auth_list()
    },
    destoryed() {},
    mounted() {},
    updated() {},
    components: {
        IndexMeuComponent,
        IndexHeaderComponent
    }
}
</script>